// extracted by mini-css-extract-plugin
export var sliderRange = "_ow-2";
export var sliderRoot = "_ow-0";
export var sliderThumb = "_ow-3";
export var sliderTrack = "_ow-1";